import React, { useEffect, useState } from "react";
import {
  Badge,
  Button,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  Col,
} from "reactstrap";
import { payoutDetailRows } from "../../../utils/payoutDetails";

const DetailRow = ({ label, value }) => (
  <Row className="mb-2">
    <Col xs="5" className="text-muted small">
      {label}
    </Col>
    <Col xs="7" className="small">
      {value ?? "—"}
    </Col>
  </Row>
);

const formatDate = (value) => {
  if (!value) return "—";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleString();
};

const LabelDetailModal = ({ isOpen, toggle, label, onSaveRef, isSaving }) => {
  const [invoiceRef, setInvoiceRef] = useState("");

  useEffect(() => {
    setInvoiceRef(label?.label_Inv_ref ?? "");
  }, [label]);

  if (!label) return null;

  const handleSave = (event) => {
    event.preventDefault();
    onSaveRef?.({ id: label.id, label_Inv_ref: invoiceRef });
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg">
      <ModalHeader toggle={toggle}>{label.label_name || label.name}</ModalHeader>
      <Form onSubmit={handleSave}>
        <ModalBody>
          <DetailRow label="Accounting ID" value={label.id} />
          <DetailRow label="CMS Label ID" value={label.label_red_id} />
          <DetailRow label="Theme" value={label.theme_name || "—"} />
          {label.label_theme ? (
            <DetailRow label="Theme template" value={`#${label.label_theme}`} />
          ) : null}
          <DetailRow
            label="Theme colors"
            value={
              label.color1 || label.color2 ? (
                <span className="d-flex align-items-center gap-2">
                  {label.color1 ? (
                    <span
                      style={{
                        width: 18,
                        height: 18,
                        borderRadius: 4,
                        background: label.color1,
                        border: "1px solid rgba(0,0,0,0.1)",
                      }}
                    />
                  ) : null}
                  {label.color2 ? (
                    <span
                      style={{
                        width: 18,
                        height: 18,
                        borderRadius: 4,
                        background: label.color2,
                        border: "1px solid rgba(0,0,0,0.1)",
                      }}
                    />
                  ) : null}
                </span>
              ) : (
                "—"
              )
            }
          />
          <DetailRow label="Email" value={label.email} />
          <DetailRow label="Phone" value={label.phone_number} />
          <DetailRow label="Address" value={label.address} />
          <DetailRow label="ISRC code" value={label.isrc_code} />
          <DetailRow
            label="Artists"
            value={
              label.artists_count ? (
                <Badge color="primary">{label.artists_count}</Badge>
              ) : (
                "—"
              )
            }
          />
          {payoutDetailRows(label).map((row) => (
            <DetailRow key={row.label} label={row.label} value={row.value} />
          ))}
          <DetailRow label="Created" value={formatDate(label.created_at)} />
          <DetailRow label="Updated" value={formatDate(label.updated_at)} />

          <FormGroup className="mt-3">
            <Label for="labelInvRef">Invoice reference prefix</Label>
            <Input
              id="labelInvRef"
              value={invoiceRef}
              onChange={(e) => setInvoiceRef(e.target.value)}
              placeholder="e.g. RD-"
            />
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" outline onClick={toggle}>
            Close
          </Button>
          <Button color="primary" type="submit" disabled={isSaving}>
            {isSaving ? "Saving..." : "Save invoice ref"}
          </Button>
        </ModalFooter>
      </Form>
    </Modal>
  );
};

export default LabelDetailModal;
